import { productApi } from '@api/product.api';
import { ProductSearchData, ProductSearchResponse } from '@api/types';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

const initialState: ProductSearchData = {};

// REDUCERS
export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      productApi.endpoints.productSearch.matchFulfilled,
      (state, action: PayloadAction<ProductSearchResponse>) => {
        return { ...state, ...action.payload.data };
      }
    );
  },
});

// ACTIONS

// SELECTORS

export const getProducts = createSelector(
  (state: RootState) => state.products,
  (value) => value
);

export default productsSlice.reducer;
